import React from "react"
import {
  AutoPilot,
  BetAmount,
  BetAmountContainer,
  BetAmountWrapper,
  BetBlock,
  BetBlockWrapper,
  BetButton,
  Operation,
  Operations,
  SubText,
  Text,
} from "../GameRulesStyles"
import HistoryImg from "../../../lib/assets/img/history.png"

export default function WinRules() {
  return (
    <>
      <Text className={"big green"} margin={"0 0 10px"}>
        How To Win
      </Text>
      <Text className={"big white"} margin={"0 0 10px"}>
        AFTER ROUND STARTS, YOUR <SubText className={"blue"}>Bet </SubText>WILL
        TURN INTO <SubText className={"green"}>Cashout </SubText>, SO YOU CAN
        DETERMINATE YOUR LUCK AND CLICK ON{" "}
        <SubText className={"green"}>Cashout </SubText>, BUTTON BEFORE SHUTTLE{" "}
        <SubText className={"red"}>Explosion</SubText>.
      </Text>
      <Text className={"small white"} margin={"0 0 10px"}>
        *WINNING AMOUNT DETERMINATED BY
        <SubText className={"blue"}> Multiplier </SubText> REACHED BY SHUTTLE
      </Text>
      <BetBlockWrapper>
        <BetBlock>
          <AutoPilot>autopilot</AutoPilot>
          <BetAmountContainer>
            <BetAmountWrapper>
              <BetAmount>
                <p>bet amount</p>
                <span>$10.00</span>
              </BetAmount>
              <Operations>
                <Operation color={"blue"}>1/2</Operation>
                <Operation>2x</Operation>
              </Operations>
            </BetAmountWrapper>
            <BetButton color={"green"}>
              <p>cashout</p>
              <span>$100.00</span>
            </BetButton>
          </BetAmountContainer>
        </BetBlock>
      </BetBlockWrapper>
      <Text className={"big red"} margin={"0 0 10px"}>
        How to see the history of previous rounds?
      </Text>
      <img src={HistoryImg} alt="" width="100%" />
    </>
  )
}
